import { ReactElement } from 'react';
import { Outlet } from 'react-router';
import { tokens } from '../../core/theme';
import { AppLink, FCBar, MAIN_CONTENT_ID, SkipLink } from '../../core/components';
import { Logo } from '../../assets/images';

export const MainLayout = (): ReactElement => {
  return (
    <div style={styles.page}>
      <SkipLink />
      <header style={styles.header}>
        <div style={styles.fcBarWrapper}>
          <FCBar />
        </div>
        <div style={styles.logoContainer}>
          <AppLink to={'/'} aria-label="Página inicial">
            <Logo />
          </AppLink>
        </div>
      </header>
      <main id={MAIN_CONTENT_ID} tabIndex={-1} style={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: tokens.colors.surface.page,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    width: '100%',
  },
  fcBarWrapper: {
    backgroundColor: tokens.colors.global.white,
    borderBottom: `1px solid ${tokens.colors.border.header}`,
    width: '100%',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: tokens.spacing.headerLogoPadding,
  },
  content: {
    flex: 1,
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
  },
};
